import { compact } from 'lodash-es';
import { useOverlayContext, useStoreActions, useStoreStatic } from '~/contexts';
import { useAgreements } from '~/hooks/reactQuery/queries/useAgreements';
import { useContacts } from '~/hooks/reactQuery/queries/useContacts';
import { useLegalTerms } from '~/hooks/reactQuery/queries/useLegalTerms';
import { useProposals } from '~/hooks/reactQuery/queries/useProposals';
import { useQboClasses } from '~/hooks/reactQuery/queries/useQboClasses';
import { agreementStudioAgreementsArgs } from '~/pages/AgreementsDashboard/agreementsDashboardFilters';
import { selectors } from '~/store/state-selectors';
export function useFetchAgreementStudioData(options) {
    const { fetchFinancialCentsUsers, fetchKarbonUsers } = useStoreActions();
    const { refresh: fetchAgreements } = useAgreements(agreementStudioAgreementsArgs);
    const { refresh: fetchContacts } = useContacts();
    const { refresh: fetchLegalTerms } = useLegalTerms();
    const { refresh: fetchProposals } = useProposals();
    const { refresh: fetchQboClasses } = useQboClasses();
    const { disableLoader, disableLegalTerms, disableContacts, disableAgreements, disableProposals, disableQboClasses, disableFinancialCentsUsers, disableKarbonUsers } = options || {};
    const { startLoader, stopLoader } = useOverlayContext();
    const { getState } = useStoreStatic();
    return function fetchAgreementStudioData() {
        if (!disableLoader) {
            startLoader();
        }
        const requests = compact([
            !disableLegalTerms && fetchLegalTerms(),
            !disableContacts && fetchContacts(),
            !disableAgreements && fetchAgreements(),
            !disableProposals && fetchProposals(),
            !disableQboClasses && fetchQboClasses(),
            !disableFinancialCentsUsers && selectors.integration.showFinancialCentsIntegration(getState()) && fetchFinancialCentsUsers(),
            !disableKarbonUsers && selectors.integration.showKarbonIntegration(getState()) && fetchKarbonUsers()
        ]);
        Promise.all(requests).catch(()=>{}).finally(()=>{
            if (!disableLoader) {
                stopLoader();
            }
        });
    };
}
